"use client";
import Image from "next/image";
import Link from "next/link";
import { type FC, useMemo } from "react";
import config from "@/app/context/config";
import { useAppSelector } from "@/app/redux/hooks";
import LogoLight from "@/assets/images/logos/light-logo.png";
import LightMiniSidebarLogo from "@/assets/images/logos/light-mini-sidebar.png";
import LogoDark from "@/assets/images/logos/logo.png";
import MiniSidebarLogo from "@/assets/images/logos/mini-sidebar.png";

/**
 * There used to be a second copy of this whole return for RTL. It imported
 * `logo.png` and `light-logo.png` under RTL names - the same two files - so the
 * branch picked between a logo and itself. It went with the direction setting.
 */
const Logo: FC = () => {
	const { isCollapse, isSidebarHover, activeMode } = useAppSelector(
		(state) => state.customizer,
	);

	const width = useMemo(() => {
		return isCollapse === "mini-sidebar" && !isSidebarHover ? "40px" : "160px";
	}, [isCollapse, isSidebarHover]);

	const isMinSidebar = isCollapse === "mini-sidebar" && !isSidebarHover;
	const isDark = activeMode === "dark";

	const source = isMinSidebar
		? isDark
			? LightMiniSidebarLogo
			: MiniSidebarLogo
		: isDark
			? LogoLight
			: LogoDark;

	const dimensions = isMinSidebar
		? { width: 40, height: 40 }
		: { width: 180, height: 60 };

	return (
		<Link
			href="/"
			className="flex items-center overflow-hidden"
			style={{ height: config.topbarHeight, width }}
		>
			<Image
				src={source}
				alt="Logo"
				width={dimensions.width}
				height={dimensions.height}
				priority
				style={{ maxWidth: "100%", height: "auto" }}
			/>
		</Link>
	);
};

export default Logo;
